const TEAM_ROLES = [
    {
        name: "king",
        displayName: "Owner",
        description: "",
        hidden: true
    },
    {
        name: "queen",
        displayName: "Admin",
        description: "Can invite and remove members, update billing information and settings",
        icon: "icQueen",
        emoji: "👑"
    },
    {
        name: "rook",
        displayName: "Editor/Developer",
        description: "Can create and manage projects, screens and styleguide resources",
        icon: "icRook",
        emoji: "🎩"
    },
    {
        name: "pawn",
        displayName: "Reviewer",
        description: "Can access all projects, view screens and add notes",
        icon: "icPawn",
        extraInfo: "(Free of charge)",
        emoji: "🧐"
    }
];

const ORGANIZATION_ROLES = [
    {
        name: "king",
        displayName: "Owner",
        description: "",
        hidden: true
    },
    {
        name: "queen",
        displayName: "Admin",
        description: "Can invite and remove members, update billing information and settings",
        icon: "icQueen",
        emoji: "👑"
    },
    {
        name: "rook",
        displayName: "Editor",
        description: "Can create and manage projects, screens and styleguide resources",
        icon: "icRook",
        emoji: "🎩"
    },
    {
        name: "knight",
        displayName: "Developer",
        description: "Can access all projects, technical specs, assets, code snippets and add notes",
        icon: "icKnight",
        emoji: "👓"
    },
    {
        name: "pawn",
        displayName: "Reviewer",
        description: "Can access all projects, view screens and add notes",
        icon: "icPawn",
        extraInfo: "(Free of charge)",
        emoji: "🧐"
    }
];

export {
    TEAM_ROLES,
    ORGANIZATION_ROLES
};
